<template>
	<div style="background:transparent;box-shadow: none;padding: 0;" v-loading="loading">
		<sbspSalaryFilter :filterList.sync="filterList">
			<el-form-item label="工资月份：" style="margin-right:40px;">
				<div style="display: flex;align-items: center;">
          <el-select  v-model="filterList[0].value"   placeholder="请选择" style="width:110px;" @change="dateWageChange()">
            <el-option  v-for="item in filterList[0].options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker class="el-date" v-if="filterList[0].value=='92480004'" v-model="wageTime.month"  style="width:230px;margin-left:4px;"
                          type="monthrange"
                          range-separator="至"
                          value-format="yyyy-MM"
                          start-placeholder="开始月份"
                          end-placeholder="结束月份">
          </el-date-picker>
				</div>
			</el-form-item>

		</sbspSalaryFilter>
		<div class="carBox" ref="carBox" >
				   <div v-if="cardDatas.length== 0&&showNodata" style="margin: 0 auto;">
							<noData style="margin-top: 200px;" msg="暂无数据"></noData>
						</div>
			<cardTwo v-for="(cardData,i) in cardDatas" :key="i" :cardData='cardData' :labels='labels'>
				<div class="leftButtonCon">
					<!-- && cardData.state!='92530002' -->
					<leftButton title="支付文件"
											v-if=" (cardData.info[4]== '92500003' && (cardData.state == '92530002' || cardData.state == '92530004')) "
											@click="downloadPayFile(cardData.batchId,cardData.info[4])" ></leftButton>
					<leftButton title="删除批次"
											v-if=" (cardData.info[4]== '92500003' || cardData.info[4]== '92500004' ) && cardData.state == '92530004'"
											@click="deletePayBatch(cardData.batchId,cardData.info[4])" ></leftButton>
					<leftButton title="确认发放"
											v-if=" (cardData.info[4]== '92500003') && cardData.state == '92530004'"
											@click="_comfirmPay(cardData.batchId)" ></leftButton>
					<leftButton title="查看详情" @click="wageDetail(cardData.batchId,cardData.info[4],cardData.wageTmplId)" ></leftButton>
				</div>

			</cardTwo>
		</div>
		<p class="more">
      <span @click="moreData()" v-if="msgPage.page*msgPage.limit<msgPage.total" >查看更多</span>
		</p>

		<!--  报盘文件弹窗-->
    <el-dialog
			ref="paybankFileDialog"
			width="800px"
			v-dialogDrag
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			title="支付情况"
			v-loading="loading"
			:visible.sync="paybankFileDialogVisible">
      <div class="marginTop30" style="text-align: center">
      <span>
        {{paybankError}}
      </span>
			<el-table
					:data="paybankFileList"
					border
					style="width: 100%;margin:20px">
					<el-table-column
						prop="banktype"
						label="付款银行"
						width="150">
						<template slot-scope="scope">
							<span>{{ scope.row.banktype | dictFilter(dicts)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="bankacount" label="付款账户" width="200" ><!--:showPagination="false"-->
						<template slot-scope="scope">
							<span>{{ scope.row.bankacount }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="bankacount" label="收款银行" width="150" ><!--:showPagination="false"-->
						<template slot-scope="scope">
							<span>{{ scope.row.payeebanktype | dictFilter(dicts)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="paynum" label="发薪人数" width="120" ><!--:showPagination="false"-->
						<template slot-scope="scope">
							<span>{{ scope.row.paynum }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="sumamount" label="发薪总额(元)" width="120" ><!--:showPagination="false"-->
						<template slot-scope="scope">
							<span>{{ scope.row.sumamount }}</span>
						</template>
					</el-table-column>
			</el-table>

        <el-button type="primary" @click="handlerPaybankFileDialog" > 确定 </el-button>
        <el-button type="primary" @click="handlePaybankFileDialog" > 加密下载 </el-button>
      </div>
    </el-dialog>
    <!-- 模态对话框 -->
    <el-dialog :visible.sync="dialogVisible" width="30%" v-dialog-drag>
      <span>加密密码</span>
      <el-input v-model="backendValue"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="downloadFile">下 载</el-button>
      </span>
    </el-dialog>

	</div>
</template>

<script>

	import sbspSalaryFilter from "@/wage-components/sbs-salary-filter/sbsp-salary-filter.vue"
	import cardTwo from "@/wage-components/sbs-salary-card/cardTwo.vue"
	import leftButton from "@/wage-components/sbs-salary-card/left-button.vue"
  import noData from "@/wage-components/bsp-noData/bsp-noData.vue"
  import { encrypt, decrypt } from '@/util/util';
  import {
		titileDetails,
		deleteByBatchId,
		createdPayFile,
		comfirmPay,
		getPaybankFileList,
    queryPwd
	} from "@/api/wage/pay.js"
	import {
		downloadEmpExcelTmpl
	} from "@/api/common/common";
	import {
		downloadFile,
		deepCopy
	} from "@/util/util";
	import {
		queryPmsPayGroupTree
	} from "@/api/wage/payGroup";
	import {
		commonConst
	} from "@/const/code"
	import { mapGetters } from 'vuex';

	export default {
		name: "approval",
		components: {
			sbspSalaryFilter,
			cardTwo,
      noData,
			leftButton
		},
		computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
		data() {
			return {
        msgPage: {
            limit: 6,
            page: 1,
            total: 0,
            monthStr:'92480001',
						monthStart:'',
						monthEnd:'',
        },
				wageTime:{
					month:'',
				},
				loading:false,
				showNodata:false,
				labels: ["工资月份", "发薪人数", "发薪金额", "薪酬组", "发放类型"],
				cardDatas: [], //信息栏
				cardDatasDetail: {
					type: Object,
					default: {},
				},
				params: { //下拉框传参对象
					filterTextValue: "",
					filterOptionValue: ""
				},
				filterList: [
				    {
						text: "工资月份",
						type: 'select-timer',
            name: 'wageMonth',
						value: commonConst.THE_THREE_MONTH,
						options: [{
							value: commonConst.THE_CURRENT_MONTH,
							label: '当前月'
						}, {
							value: commonConst.THE_THREE_MONTH,
							label: '近三个月'
						}, {
							value: commonConst.THE_YEAR,
							label: '近一年'
						}, {
							value: commonConst.THE_HISTORY,
							label: '其他'
						}]
					},
          // { text: "批次名称", type: 'te' +
          //     'xt',value:'',name:'batchName'},
          { text: "", type: 'te' +
              'xt',value:'',name:'batchName'},
          { text: "薪酬组", type: 'treeSelect',value:[],multiple:true,name:'groupId',
              defaultGroupProps:{
                  children: 'children',
                  label: 'groupName',
                  value: 'id',
              },
              options: []
          },
          {
            text: "社保月份",
            type: 'timer',
            value: '',
            name: 'socMonth',
            format: 'yyyy-MM',
            pickerType: 'month'
          },
          {
            text: "税金月份",
            type: 'timer',
            value: '',
            name: 'taxMonth',
            format: 'yyyy-MM',
            pickerType: 'month'
          },
					{
						text: "计税类型",
						type: 'select',
						value:[],
						multiple:true,
						name:'taxType',
						dicts:'9245',
						remNum:"92450002,92450004,92450007"
					 },
					{
						text: "发放状态",
						type: 'select',
						value:[],
						multiple:true,
						name:'payoutStatus',
						dicts:'9253',
						remNum:"92530001,92530006	"
					}
				],
				paybankFileDialogVisible:false,
				paybankFileParam:{},
				paybankFileList:[],
				paybankFileListQuery: {
          limit: 10,
          page: 1,
          total: 0,
          tenantId: '',
				},
				paybankError:"",
        dialogVisible: false, // 加密页面
        backendValue: '' // 回显密码
			};
		},
    watch:{
        filterList:{//深度监听，可监听到对象、数组的变化
            handler(val, oldVal){
                val.map((item)=>{
                    if(item.value2){
                        this.$set(this.msgPage,item.name,item.value2);
                    }else{
                        if(item.value2==''&&item.value){
                            this.$set(this.msgPage,item.name,item.value.split(','));
                        }else{
                            this.$set(this.msgPage,item.name,item.value);
                        }
                    }
                })
                this.$set(this.msgPage,'page',1);
                if(this.msgPage.wageMonth=='92480004'){
                    return ;
                }
                this._queryListPageQuery();
            },
            deep:true //true 深度监听
        },
				wageTime:{
					handler(val, oldVal){

							let month = val.month;
							this.$set(this.msgPage,'monthStart',month[0]);
							this.$set(this.msgPage,'monthEnd',month[1]);
							this._queryListPageQuery();
						},
						deep:true //true 深度监听
				}
    },
		created() {
			// this._queryListPageQuery()
			this._queryPmsPayGroupTree() //查询薪酬组树

		},
		mounted() {
			window.addEventListener('scroll', () => {
				if(this.$refs.carBox&&this.cardDatas.length!=6){
					var top = this.$refs.carBox.getBoundingClientRect().top;
					var height = this.$refs.carBox.clientHeight;
					console.log(top + height - document.getElementsByClassName('main')[0].clientHeight)
					if (top + height - document.getElementsByClassName('main')[0].clientHeight < 60) {
						this.moreData();
					}
				}
			}, true);
		},
		methods: {
        dateWageChange(val){
            if(this.filterList[0].value!='92480004'){
                this.$set(this.msgPage,'monthStart','');
                this.$set(this.msgPage,'monthEnd','');
            }
        },
      //获取薪酬组数据
      _queryPmsPayGroupTree() {
          queryPmsPayGroupTree().then(res => {
              let rs = res.data
              if (rs.code == 0) {
                  // this.filterList[2].value = [rs.data[0].id]
                  this.filterList[2].options = rs.data;
                  // console.log(rs.data,222222222222222)
                  this.filterLists = JSON.parse(JSON.stringify(this.filterList));
              }
          })
      },
      _queryListPageQuery() {
				this.loading=true;
				titileDetails(this.msgPage).then(res => {
						this.$set(this.msgPage,'limit',res.data.size);
						this.$set(this.msgPage,'page',res.data.current);
						this.$set(this.msgPage,'total',res.data.total);
						this.cardDatas = res.data.records;
						this.showNodata = true;
						this.loading=false;
						console.log("测试数据cardDatas---" , this.cardDatas);
						console.log("测试数据cardDatas---" , this.msgPage);
				}).catch(err=>{
					this.loading=false
				});
			},
			handlerPaybankFileDialog(){
				let batchId = this.paybankFileParam.batchIds;
				let params = {
					batchId: batchId,
					detailIDs:[]
				}
				let payWay = this.paybankFileParam.payWays;
				if (commonConst.PAY_WAY_UNDERLINE == payWay) {
					if(!this.paybankFileList || this.paybankFileList.length==0){
						this.paybankFileDialogVisible = false;
						this.$message.error("无银行数据")
						return
					}
					this.loading = true;
					console.log("点击生成支付文件：" + params.batchId);
					createdPayFile(params).then(res => {
						this.loading = false;
						downloadFile(res);
						if(res.status==200){
							this.$message.success("报盘文件下载成功！")
							this._queryListPageQuery() //刷新
						}else{
							this.$message.error( "报盘文件下载失败！")
						}
					}).catch(err=>{
						this.loading=false
					})
				} else {
					this.$message.error("非线下发放")
				}
			},
			downloadPayFile(batchId, payWays) {
				this.paybankError = "";
				this.loading = true;
				this.paybankFileList = [];
				let param = {
					batchId:batchId,
					detailIDs:[]
				}
				//查询发薪银行信息  paybankFileList
				getPaybankFileList(param).then(res=>{
					this.loading = false;
					console.log('查询发薪银行信息',res)
					if(res.data.code!=0){
						this.paybankError = res.data.msg;
					}

					this.paybankFileListQuery.total = res.data.total
					this.paybankFileList = deepCopy(res.data.data);
				}).catch(err=>{
					this.loading=false
				})

				this.paybankFileDialogVisible = true;
				this.$set(this.paybankFileParam,'batchIds',batchId)
				this.$set(this.paybankFileParam,'payWays',payWays)
			},
      //删除发薪明细
			deletePayBatch(batchId, payWay) {
				//线下发薪和系统发薪时，才能删除
				if (commonConst.PAY_WAY_UNDERLINE == payWay || commonConst.PAY_WAY_SYSTEM == payWay) {
            this.$confirm('是否删除该批次数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((action) => {
                if(action === 'confirm'){
									this.loading = true;
									deleteByBatchId(batchId).then(res => {
											this.loading = false;
											if (res.data.code == 0) {
												this.$message.success('删除成功');

													this._queryListPageQuery() //刷新
											} else {
												this.$message.error( '删除失败');
											}
									}).catch(err=>{
										this.loading=false
									})
                }
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });
				} else {
					this.$message.error('非线下发放')
				}
			},
			_comfirmPay(batchId) {
          this.$confirm('是否确认发放?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then((action) => {
              if(action === 'confirm'){
                  let parm = {
                      batchId: batchId
                  }
									this.loading = true;
                  comfirmPay(parm).then(res => {
										this.loading = false;
										if (res.data.code == 0) {
											this.$message.success('确认发放完成');

												this._queryListPageQuery() //刷新
										} else {
												// this.$message({
												//     type: "error",
												//     message: '确认发放失败'
												// })
										}
                  }).catch(err=>{
										console.log(err)
										this.loading=false
									});
              }
          }).catch(() => {
              // this.$message({
              //     type: 'info',
              //     message: '已取消删除'
              // });
          });
			},
			wageDetail(batchIds, payWays,wageTmplId) {
				// this.cardDatasDetail=obj;
				let batchId = batchIds;
				let payWay = payWays;
				const query = {
					batchId: batchId,
					payWay: payWay,
					wageTmplId:wageTmplId
				}
				console.log("编辑参数query=", query);
				if (commonConst.PAY_WAY_UNDERLINE == payWay) {
					this.$router.push({
						path: '/payrollSettings/payOutUnderGroupTable',
						query
					});
				} else {
					this.$message.error('非线下发放')
				}
			},
      moreData(){
				if(this.isBottom){
						return;
				}
				this.$set(this.msgPage,'page',this.msgPage.page+1);
				this.loading = true;
				titileDetails(this.msgPage).then((res)=>{
						if(res.data.records.length<this.msgPage.limit){
								this.$set(this.msgPage,'limit',res.data.size);
								// this.$set(this.msgPage,'page',res.data.current);
								this.$set(this.msgPage,'total',res.data.total);
								this.isBottom = true;
						}
						this.cardDatas = this.cardDatas.concat(res.data.records);
						this.loading = false;

				}).catch(err=>{
					this.loading=false
				})
      },
      async handlePaybankFileDialog() {
        //查询发薪银行信息  paybankFileList
        queryPwd().then(res=>{
          if(res.data.code===0){
            if (res.data.data!=''){
              this.backendValue = decrypt(res.data.data);
            }
          }
          this.loading = false;
          this.dialogVisible = true;
        }).catch(err=>{
          this.loading=false
        })
      },
      downloadFile() {
        let batchId = this.paybankFileParam.batchIds;
        let params = {
          batchId: batchId,
          detailIDs:[],
          key:encrypt(this.backendValue)
        }
        let payWay = this.paybankFileParam.payWays;
        if (commonConst.PAY_WAY_UNDERLINE == payWay) {
          if(!this.paybankFileList || this.paybankFileList.length==0){
            this.paybankFileDialogVisible = false;
            this.$message.error("无银行数据")
            return
          }
          this.loading = true;
          console.log("点击生成支付文件：" + params.batchId);
          createdPayFile(params).then(res => {
            this.loading = false;
            downloadFile(res);
            if(res.status==200){
              this.$message.success("报盘文件下载成功！")
              this._queryListPageQuery() //刷新
            }else{
              this.$message.error( "报盘文件下载失败！")
            }
          }).catch(err=>{
            this.loading=false
          })
        } else {
          this.$message.error("非线下发放")
        }
        this.dialogVisible = false;
      }
		}
	};
</script>

<style scoped>
	.el-date.el-date-editor >>> 	 .el-range__close-icon{
			line-height: 20px;
		}
	.carBox {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}


	.more span {
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(64, 158, 255, 1);
		line-height: 18px;
		cursor: pointer;
	}

	.more {
		text-align: right;
	}

	.more span:hover {
		text-decoration: underline;

	}

</style>
